import { Button } from "@/components/ui/button";
import { Loader2Icon } from "lucide-react";
import type { CreditCardPaymentButtonProps } from "@/interfaces";
import type { MouseEventHandler } from "react";
import React from "react";
import Icons from "@/components/Icons";
import type { ThemeConfig } from "@/lib/theme-utils";

type Props = CreditCardPaymentButtonProps & {
  onClick?: MouseEventHandler<HTMLButtonElement>;
  hideIcon?: boolean;
  theme?: ThemeConfig;
};

const CreditCardPaymentButton = React.forwardRef<HTMLDivElement, Props>(
  ({ placeHolder, isLoading, isDisabled, onClick, hideIcon = false, theme }, ref) => {
    return (
      <div className="flex flex-col gap-[10px]" ref={ref}>
        {isLoading ? (
          <Button variant="disabled" disabled className="min-h-[48px]" theme={theme}>
            <Loader2Icon className="animate-spin" />
            Please wait
          </Button>
        ) : (
          <Button
            variant={isDisabled ? "disabled" : "checkoutWithCard"}
            type={onClick ? "button" : "submit"}
            disabled={isDisabled}
            onClick={onClick}
            className="min-h-[48px] flex items-center gap-3"
            theme={theme}
          >
            {!hideIcon && (placeHolder === "Add New Card" || placeHolder?.includes("Add")) && (
              <Icons type="addCard" size={20} />
            )}
            {placeHolder || "Pay"}
          </Button>
        )}
      </div>
    );
  }
);

export default CreditCardPaymentButton;
